import { useEffect } from "react";

// Module-level count so NESTED dialogs (modal over drawer, confirm over modal)
// don't unlock the body while an outer layer is still open.
let locks = 0;

export function useLockBodyScroll(lock: boolean) {
  useEffect(() => {
    if (!lock) return;
    locks++;
    if (locks === 1) {
      // Compensate for the vanishing scrollbar, or the whole page shifts
      // sideways by the scrollbar width the moment a dialog opens.
      const gap = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = "hidden";
      if (gap > 0) document.body.style.paddingRight = `${gap}px`;
    }
    return () => {
      locks--;
      if (locks === 0) {
        document.body.style.overflow = "";
        document.body.style.paddingRight = "";
      }
    };
  }, [lock]);
}
